import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomMovimientosCaja
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0009.8
 **/
class CustomMovimientosCaja extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                         = this.initForm.bind(this);
        this.gridOptionsComponentes           = Object.assign({}, this.gridOptions);
        this.grabarMovimiento                 = this.grabarMovimiento.bind(this);
        this.successGrabarMovimiento          = this.successGrabarMovimiento.bind(this);
        this.limpiar                          = this.limpiar.bind(this);
        this.successValidarSaldo              = this.successValidarSaldo.bind(this);
    }

    initForm(){
     
        console.log('Formulario CustomMovimientosCaja,  @version: jdesk_1.01.0009.8, @author: Patricia Lopez Sanchez');
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;

        this.getField('usuario').setValue(this.codigo_usuario);

        this.getField('crear_movimiento').setClick(this.grabarMovimiento);
        this.getField('cancelar').setClick(this.limpiar);

        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} },
        { 'text': 'Ingreso', 'value': 'INGRESO', 'campos_cambian': {} },
        { 'text': 'Egreso', 'value': 'EGRESO', 'campos_cambian': {} }
        ];

        this.getField('tipo').setOptions(opciones);
        this.getField('tipo').setOnChange(()=>{
            if(this.getField('tipo').getValue() === 'EGRESO'){
                if(this.getField("valor").getValue() > 0){
                    this.getField("valor").setValue("-"+this.getField("valor").getValue())
                }
            }else{
                this.getField("valor").setValue(Math.abs(this.getField("valor").getValue()));
            }
        });

    }

    grabarMovimiento(){
        if(this.getField("cajas_id").valid() && this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() && this.getField("codigo_facturacion").valid()
        && this.getField("valor").valid() && this.getField("detalle").valid() && this.getField("tipo").valid() && this.getField("categoria").valid()
        && this.getField("formas_pago").valid() && this.getField("numero_referencia").valid() && this.getField("usuario").valid()){

            if(this.getField("valor").getValue() !== 0){
                if(this.getField('tipo').getValue() === 'EGRESO'){
                    if(this.getField("valor").getValue() > 0){
                        this.getField("valor").setValue("-"+this.getField("valor").getValue())
                    }
                }else{
                    this.getField("valor").setValue(Math.abs(this.getField("valor").getValue()));
                }

                let error = 0;
                if(this.getField('categoria').getValue() === '7'){
                    if(this.getField("valor").getValue() < 0){
                        this.getField('valor').setError(true, 'Si la categoria es base caja el valor no puede ser negativo.', 'error');
                        error++;
                    }
                    if(this.getField('tipo').getValue() === 'EGRESO'){
                        this.getField('tipo').setError(true, 'Si la categoria es base caja el tipo no puede ser un egreso.');
                        error++;
                    }else{
                        this.getField('tipo').setError(false, '');
                        this.getField('valor').setError(false, '');
                    }
                }

                if(error === 0){
                    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está grabando la información... `);
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField('confirmModalCustom').toggle(true);
        
                    if(this.getField('tipo').getValue() === 'EGRESO'){
                        let datos = { datos: {
                            cajas_id: this.getField("cajas_id").getValue(),
                            valor: this.getField("valor").getValue(),
                            formas_pago: this.getField("formas_pago").getValue(),
                        }};
                    
                        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'traer_saldo_forma_pago', operacion_tipo: 'consulta' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method:'GET',
                            body: datos,
                            success: this.successValidarSaldo,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                    }else{
                        let datos = { datos: {
                            cajas_id: this.getField("cajas_id").getValue(),
                            codigo_sucursal2: this.getField("codigo_sucursal").getValue(),
                            codigo_facturacion2: this.getField("codigo_facturacion").getValue(),
                            valor: this.getField("valor").getValue(),
                            detalle: this.getField("detalle").getValue().replace(/<[^>]+>/g, ''),
                            tipo: this.getField("tipo").getValue(),
                            categoria: this.getField("categoria").getValue(),
                            formas_pago: this.getField("formas_pago").getValue(),
                            numero_referencia: this.getField("numero_referencia").getValue(),
                            usuario2: this.getField("usuario").getValue()
                        }};
                    
                        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'grabar_movimiento', operacion_tipo: 'crear' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method:'POST',
                            body: datos,
                            success: this.successGrabarMovimiento,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                    }
                }
            }else{
                this.alertGeneral.toggle(true, 'El valor no puede estar en 0.', 'error');
            }
        }else{
            this.getField('confirmModalCustom').toggle(false);
            this.alertGeneral.toggle(true, 'Debe diligenciar todos los campos ', 'error');
        }
    }

    successValidarSaldo(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            let datos = { datos: {
                cajas_id: this.getField("cajas_id").getValue(),
                codigo_sucursal2: this.getField("codigo_sucursal").getValue(),
                codigo_facturacion2: this.getField("codigo_facturacion").getValue(),
                valor: this.getField("valor").getValue(),
                detalle: this.getField("detalle").getValue().replace(/<[^>]+>/g, ''),
                tipo: this.getField("tipo").getValue(),
                categoria: this.getField("categoria").getValue(),
                formas_pago: this.getField("formas_pago").getValue(),
                numero_referencia: this.getField("numero_referencia").getValue(),
                usuario2: this.getField("usuario").getValue()
            }};
        
            this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'grabar_movimiento', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarMovimiento,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else{
            this.mostrarMensajeAdicional(data.data.mensaje);
        }
    }

    successGrabarMovimiento(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            this.limpiar();
            this.alertGeneral.toggle(true, 'Se grabo el movimiento de manera correcta.', 'success');
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }
    
    limpiar(){
        this.getField('cajas_id').setValue('');
        this.getField('codigo_sucursal').setValue('');
        this.getField('nombre_sucursal').setValue('');
        this.getField('codigo_facturacion').setValue('');
        this.getField('valor').setValue('');
        this.getField('estado').setValue('');
        this.getField('detalle').setValue('');
        this.getField('tipo').setValue('');
        this.getField('categoria').setValue('');
        this.getField('formas_pago').setValue('');
        this.getField('numero_referencia').setValue('');

        this.getField('cajas_id').setError(false,'');
        this.getField('codigo_sucursal').setError(false,'');
        this.getField('nombre_sucursal').setError(false,'');
        this.getField('codigo_facturacion').setError(false,'');
        this.getField('valor').setError(false,'');
        this.getField('detalle').setError(false,'');
        this.getField('tipo').setError(false,'');
        this.getField('categoria').setError(false,'');
        this.getField('formas_pago').setError(false,'');
        this.getField('numero_referencia').setError(false,'');
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }
}
FormJaivana.addController("fact-movimiento",CustomMovimientosCaja);
export default CustomMovimientosCaja